const stripDiacritics = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const normalizeText = (value) => {
    if (value === null || value === undefined) return '';
    return stripDiacritics(String(value))
        .toUpperCase()
        .replace(/\s+/g, ' ')
        .trim();
};

const normalizeSerial = (value) => normalizeText(value).replace(/[^A-Z0-9]/g, '');

const isEmpty = (value) => {
    if (value === null || value === undefined) return true;
    if (typeof value === 'boolean') return false;
    return String(value).trim() === '';
};

const FUEL_SYNONYMS = {
    GASOLINA: 'GASOLINA',
    GASOLINE: 'GASOLINA',
    DIESEL: 'DIESEL',
    ELECTRICO: 'ELECTRICO',
    ELECTRICA: 'ELECTRICO',
    HIBRIDO: 'HIBRIDO',
    HIBRIDA: 'HIBRIDO',
};

const YES_VALUES = new Set(['SI', 'SÍ', 'YES', 'TRUE', '1']);
const NO_VALUES = new Set(['NO', 'FALSE', '0']);

const normalizeFuel = (value) => {
    const normalized = normalizeText(value).replace('Í', 'I');
    return FUEL_SYNONYMS[normalized] || normalized;
};

const normalizeYesNo = (value) => {
    if (typeof value === 'boolean') return value ? 'SI' : 'NO';
    const normalized = normalizeText(value);
    if (YES_VALUES.has(normalized)) return 'SI';
    if (NO_VALUES.has(normalized)) return 'NO';
    return normalized;
};

const pickPlacApiValue = (data, paths) => {
    for (const path of paths) {
        const value = path.split('.').reduce((acc, key) => acc?.[key], data);
        if (!isEmpty(value)) return value;
    }
    return null;
};

const FIELD_COMPARISONS = [
    {
        label: 'Placa',
        formKey: 'licensePlate',
        placapiPaths: ['plate', 'informacionGeneral.noPlaca'],
        normalize: normalizeSerial,
    },
    {
        label: 'VIN',
        formKey: 'vin',
        placapiPaths: ['vin', 'informacionGeneral.noVin'],
        normalize: normalizeSerial,
    },
    {
        label: 'Chasis',
        formKey: 'chassis',
        placapiPaths: ['informacionGeneral.noChasis'],
        normalize: normalizeSerial,
    },
    {
        label: 'Motor',
        formKey: 'engine',
        placapiPaths: ['informacionGeneral.noMotor'],
        normalize: normalizeSerial,
    },
    {
        label: 'Marca',
        formKey: 'brand',
        placapiPaths: ['informacionGeneral.marca'],
        normalize: normalizeText,
    },
    {
        label: 'Línea',
        formKey: 'line',
        placapiPaths: ['informacionGeneral.linea'],
        normalize: normalizeText,
    },
    {
        label: 'Modelo / Año',
        formKey: 'year',
        placapiPaths: ['informacionGeneral.modelo'],
        normalize: normalizeText,
    },
    {
        label: 'Combustible',
        formKey: 'fuel',
        placapiPaths: ['informacionGeneral.tipoCombustible'],
        normalize: normalizeFuel,
    },
    {
        label: 'Blindaje',
        formKey: 'armor',
        placapiPaths: ['informacionBlindaje.blindado'],
        normalize: normalizeYesNo,
    },
];

export const getPlacaApiMismatches = (vehicleData = {}, placaApiData) => {
    if (!placaApiData) return [];

    return FIELD_COMPARISONS.reduce((mismatches, field) => {
        const formValue = vehicleData[field.formKey];
        const placapiValue = pickPlacApiValue(placaApiData, field.placapiPaths);

        if (isEmpty(formValue) || isEmpty(placapiValue)) {
            return mismatches;
        }

        const normalizedForm = field.normalize(formValue);
        const normalizedPlacapi = field.normalize(placapiValue);

        if (normalizedForm && normalizedPlacapi && normalizedForm !== normalizedPlacapi) {
            mismatches.push({
                label: field.label,
                formValue: String(formValue),
                placapiValue: String(placapiValue),
            });
        }

        return mismatches;
    }, []);
};
